import {
  hideGalleryPageContentFromScreenReader,
  reenableGalleryPageContent,
} from '../modules/accessibility/visible-content';

// Reducer Functions
export const filterToggleClick = state => ({ filterToggle: !state.filterToggle });

export const mediaButtonClick = (state, action) => {
  action.event.nativeEvent.stopImmediatePropagation();
  const newFilters = Object.assign({}, state.filters);

  Object.keys(newFilters).map((key) => {
    if (typeof newFilters[key] !== 'string') {
      if (newFilters[key].name === action.filterName) {
        if (newFilters[key].active === false) {
          newFilters[key].active = true;
        } else {
          newFilters[key].active = false;
        }
      }
    }
    return false;
  });

  return {
    filters: newFilters,
  };
};

export const buttonClick = (state, action) => {
  action.event.nativeEvent.stopImmediatePropagation();
  const newFilters = Object.assign({}, state.filters);

  Object.keys(newFilters).map((key) => {
    if (typeof newFilters[key] !== 'string') {
      if (newFilters[key].name === action.filterName) {
        if (newFilters[key].active === false) {
          newFilters[key].active = true;
        } else {
          newFilters[key].active = false;
        }
      }
      if (newFilters[key].name !== action.filterName) {
        newFilters[key].active = false;
      }
    }
    return false;
  });

  return {
    filters: newFilters,
  };
};

export const closeAllDropdowns = (state) => {
  const newFilters = Object.assign({}, state.filters);

  Object.keys(newFilters).map((key) => {
    if (typeof newFilters[key] !== 'string') {
      newFilters[key].active = false;
    }
    return false;
  });

  return {
    filters: newFilters,
  };
};

export const filterClick = (state, action) => {
  const newFilters = Object.assign({}, state.filters);
  const newSelectedFilters = Object.assign({}, state.selectedFilters);
  let newSelectedFilterArray = [];

  Object.keys(newFilters).map((filterKey) => {
    if (typeof newFilters[filterKey] !== 'string') {
      newFilters[filterKey].options.map((optionItem) => {
        if (action.option.type === 'radio') {
          if (action.option.name === optionItem.name) {
            optionItem.isChecked = true;
            newSelectedFilters[filterKey] = (action.option.name === 'All' ? [] : [action.option.name]);
          } else {
            optionItem.isChecked = false;
          }
        }

        if (action.option.type === 'checkbox') {
          if (action.option.isChecked === false && action.option.name === optionItem.name) {
            optionItem.isChecked = true;
            newSelectedFilterArray = newSelectedFilters[filterKey].concat(action.option.name);
            newSelectedFilters[filterKey] = newSelectedFilterArray;
          } else if (action.option.isChecked === true && action.option.name === optionItem.name) {
            optionItem.isChecked = false;
            newSelectedFilterArray = newSelectedFilters[filterKey].filter(key => key !== action.option.name);
            newSelectedFilters[filterKey] = newSelectedFilterArray;
          } else {
            return false;
          }
        }
        return false;
      });
    }
    return false;
  });

  return {
    filters: newFilters,
    selectedFilters: newSelectedFilters,
  };
};

export const removeFilter = (state, action) => {
  const newFilters = Object.assign({}, state.filters);
  const newSelectedFilters = Object.assign({}, state.selectedFilters);
  let newSelectedFilterArray = [];

  Object.keys(newFilters).map((filterKey) => {
    if (typeof newFilters[filterKey] !== 'string') {
      newFilters[filterKey].options.map((optionItem) => {
        if (action.filterName === optionItem.name) {
          optionItem.isChecked = false;
          newSelectedFilterArray = newSelectedFilters[filterKey].filter(key => key !== action.filterName);
          newSelectedFilters[filterKey] = newSelectedFilterArray;
        }
        return false;
      });
    }
    return false;
  });

  return {
    filters: newFilters,
    selectedFilters: newSelectedFilters,
  };
};

export const clearFilters = (state) => {
  const newFilters = Object.assign({}, state.filters);
  const newSelectedFilters = Object.assign({}, state.selectedFilters);

  Object.keys(newFilters).map((filterKey) => {
    if (typeof newFilters[filterKey] !== 'string') {
      newFilters[filterKey].options.map((optionItem) => {
        if (optionItem.type === 'radio' && optionItem.value === 'All') {
          optionItem.isChecked = true;
        } else {
          optionItem.isChecked = false;
        }
        return false;
      });
    }
    return false;
  });

  Object.keys(newSelectedFilters).map((filterKey) => {
    newSelectedFilters[filterKey] = [];
    return false;
  });

  return {
    filters: newFilters,
    selectedFilters: newSelectedFilters,
  };
};

export const clearSecondaryFilters = (state) => {
  // Do not want clearFilters to remove filter for Images/Videos
  const newFilters = Object.assign({}, state.filters);
  const newSelectedFilters = Object.assign({}, state.selectedFilters);

  Object.keys(newFilters).map((filterKey) => {
    if (typeof newFilters[filterKey] !== 'string') {
      if (newFilters[filterKey].name === 'Images Or Videos') {
        return false;
      }
      newFilters[filterKey].options.map((optionItem) => {
        if (optionItem.type === 'radio' && optionItem.value === 'All') {
          optionItem.isChecked = true;
        } else {
          optionItem.isChecked = false;
        }
        return false;
      });
    }
    return false;
  });

  Object.keys(newSelectedFilters).map((filterKey) => {
    if (newFilters[filterKey].name !== 'Images Or Videos') {
      newSelectedFilters[filterKey] = [];
    }
    return false;
  });

  return {
    filters: newFilters,
    selectedFilters: newSelectedFilters,
  };
};

export const showAllFilterItems = (state, action) => {
  const newFilters = Object.assign({}, state.filters);
  const newSelectedFilters = Object.assign({}, state.selectedFilters);

  Object.keys(newFilters).map((filterKey) => {
    if (newFilters[filterKey].name === action.filterName) {
      // Hide 'Show More' button
      newFilters[filterKey].showMore = false;
      // Show all options
      newFilters[filterKey].options.map((optionItem) => {
        optionItem.isHidden = false;
        return false;
      });
    }
    return false;
  });

  return {
    filters: newFilters,
    selectedFilters: newSelectedFilters,
  };
};

export const filterArticleItems = (articleItems, state) => {
  const newArticleItems = articleItems.filter(item => (
    (state.selectedFilters.categoryFilter.length === 0 || state.selectedFilters.categoryFilter.some(filter => item.articleCategories.some(category => category.name === filter)))
  ));

  return {
    filters: state.filters,
    selectedFilters: state.selectedFilters,
    articleItems: newArticleItems,
  };
};

export const filterProductStyles = (productStyles, state) => {
  const newProductStyles = productStyles.filter(style => (
    (state.selectedFilters.productLineFilter.length === 0 || state.selectedFilters.productLineFilter.some(filter => style.productLineName === filter)) &&
    (state.selectedFilters.colorRangeFilter.length === 0 || state.selectedFilters.colorRangeFilter.some(filter => style.colorRanges.some(range => range.name === filter))) &&
    (state.selectedFilters.priceFilter.length === 0 || state.selectedFilters.priceFilter.some(filter => style.priceRatings.some(rating => rating.name === filter))) &&
    (state.selectedFilters.opacityFilter.length === 0 || state.selectedFilters.opacityFilter.some(filter => style.opacityRatings.some(rating => rating.name === filter))) &&
    (state.selectedFilters.energyEfficiencyFilter.length === 0 || state.selectedFilters.energyEfficiencyFilter.some(filter => style.energyEfficiencyRatings.some(rating => rating.name === filter))) &&
    (state.selectedFilters.choiceFilter.length === 0 || state.selectedFilters.choiceFilter.some(filter => style.popularChoicesForStyle.some(rating => rating.name === filter)))
  ));

  return {
    filters: state.filters,
    selectedFilters: state.selectedFilters,
    productStyles: newProductStyles,
  };
};

const isFilterInList = (filter, list) => {
  const arr = list.split(',');
  if (arr.find(item => item === filter)) {
    return true;
  }
  return false;
};
export const filterMediaItems = (mediaItems, state) => {
  const newMediaItems = mediaItems.filter(item => (
    (state.selectedFilters.imagesVideosFilter.length === 0 || state.selectedFilters.imagesVideosFilter.some(filter => item.type === filter.slice(0, -1))) &&
    (state.selectedFilters.productLineFilter.length === 0 || state.selectedFilters.productLineFilter.some(filter => isFilterInList(filter, item.productLineName))) &&
    (state.selectedFilters.colorRangeFilter.length === 0 || state.selectedFilters.colorRangeFilter.some(filter => isFilterInList(filter, item.colorRange))) &&
    (state.selectedFilters.designStyleFilter.length === 0 || state.selectedFilters.designStyleFilter.some(filter => isFilterInList(filter, item.designStyle))) &&
    (state.selectedFilters.roomTypeFilter.length === 0 || state.selectedFilters.roomTypeFilter.some(filter => isFilterInList(filter, item.roomType)))
  ));

  return {
    filters: state.filters,
    selectedFilters: state.selectedFilters,
    mediaItems: newMediaItems,
  };
};

export const addMediaItems = (state) => {
  // Do not want clearFilters to remove filter for Images/Videos
  const newFilters = Object.assign({}, state.filters);
  const newSelectedFilters = Object.assign({}, state.selectedFilters);

  Object.keys(newFilters).map((filterKey) => {
    if (typeof newFilters[filterKey] !== 'string') {
      if (newFilters[filterKey].name === 'Images Or Videos') {
        return false;
      }
      newFilters[filterKey].options.map((optionItem) => {
        if (optionItem.type === 'radio' && optionItem.value === 'All') {
          optionItem.isChecked = true;
        } else {
          optionItem.isChecked = false;
        }
        return false;
      });
    }
    return false;
  });

  Object.keys(newSelectedFilters).map((filterKey) => {
    if (newFilters[filterKey].name !== 'Images Or Videos') {
      newSelectedFilters[filterKey] = [];
    }
    return false;
  });

  return {
    filters: newFilters,
    selectedFilters: newSelectedFilters,
  };
};

export const assetLoadComplete = action => (
  { assetLoadComplete: action.event }
);

export const openModal = (state, action) => {
  // Check if action.item is undefined...
  if (!action.item) {
    return false;
  }
  const newMediaItems = [].concat(state.mediaItems);
  const newModal = Object.assign({}, state.modal);
  newMediaItems.map((mediaItem) => {
    if (mediaItem.id === action.item.id) {
      mediaItem.active = true;
      newModal.active = true;
      newModal.item = action.item;
    }
    return false;
  });
  let savedToFavorites = false;
  let assetId = '';
  if (action.savedItems) {
    const savedItem = action.savedItems.find(item => item['photo-url'].indexOf(action.item.id) !== -1);
    if (savedItem) {
      savedToFavorites = true;
      assetId = savedItem['photo-id'];
    }
  }
  // Hide page beneath modal
  hideGalleryPageContentFromScreenReader();
  return {
    mediaItems: newMediaItems,
    modal: newModal,
    savedToFavorites,
    assetId,
  };
};

export const closeModal = (state) => {
  // console.log(action);
  // Show page beneath modal
  reenableGalleryPageContent();
  const newMediaItems = [].concat(state.mediaItems);
  const newModal = Object.assign({}, state.modal);

  newMediaItems.map((mediaItem) => {
    // if (mediaItem.id === action.item.id) {
    mediaItem.active = false;
    newModal.active = false;
    // newModal.item = state.initialState.modal.item;
    // }
    return mediaItem;
  });

  return {
    mediaItems: newMediaItems,
    modal: newModal,
  };
};

export const getPager = (totalItems, currentPage, pageSize) => {
  /* eslint-disable no-param-reassign */
  // default to first page
  currentPage = currentPage || 1;

  // default page size is 10
  pageSize = pageSize || 12;
  /* eslint-enable no-param-reassign */

  // calculate total pages
  const totalPages = Math.ceil(totalItems / pageSize);

  let startPage;
  let endPage;

  if (totalPages > 5) {
    // more than 10 total pages so calculate start and end pages
    if (currentPage <= 3) {
      startPage = 1;
      endPage = 5;
    } else if (currentPage + 2 >= totalPages) {
      startPage = totalPages - 4;
      endPage = totalPages;
    } else {
      startPage = currentPage - 3;
      endPage = currentPage + 2;
    }
  } else {
    // less than 10 total pages so show all
    startPage = 1;
    endPage = totalPages;
  }

  // calculate start and end item indexes
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min((startIndex + pageSize) - 1, totalItems - 1);

  // create an array of pages to ng-repeat in the pager control
  const pages = [...Array((endPage + 1) - startPage).keys()].map(i => startPage + i);

  // return object with all pager properties required by the view
  return {
    totalItems,
    currentPage,
    pageSize,
    totalPages,
    startPage,
    endPage,
    startIndex,
    endIndex,
    pages,
  };
};

export const setPage = (state, action) => {
  const newPageOfItems = [].concat(state.pageOfItems);
  const newPager = Object.assign({}, state.pager);

  if (action.page < 1 || action.page > state.pager.totalPages) {
    return {
      pageOfItems: newPageOfItems,
      pager: newPager,
    };
  }

  // get new pager object for specified page
  const pager = getPager(state.mediaItems.length, action.page, state.pageSize);

  // get new page of mediaItems from mediaItems array
  const pageOfItems = state.mediaItems.slice(pager.startIndex, pager.endIndex + 1);

  // update state
  return {
    pageOfItems,
    pager,
  };
};
